<template>
  <div class="dbox cmp-booking-bookings-booking_sidewindow-checklist">
    <div class="dt-list-group">
      <div
        class="dt-list-group--item"
        v-for="(group, index) in checklist"
        :key="group.value"
        :style="{
          height: `${
            group.children.length == 3
              ? 80
              : group.children.length == 2
              ? 56
              : group.children.length == 1
              ? 32
              : 32
          }px`,
        }"
      >
        <div class="group-icon">
          <img
            v-if="group.value != 'finance'"
            class="dt-icon s2"
            :src="`static/icons/${group.getIcon(group.children)}`"
            alt
          />
          <img
            v-if="group.value == 'finance'"
            class="dt-icon s2"
            :src="`static/icons/${group.getIcon(group.children, booking.finance_status)}`"
            alt
          />
        </div>
        <div class="group-title ut-text-secondary">{{ $t(group.tkey) }}</div>
        <div class="group-body dt-list">
          <div class="dt-list-item" v-for="cl of group.children" :key="cl.text">
            <div class="dt-list-item--options">
              <div class="dt-checkbox v2 s1" :class="[cl.dataState]">
                <input
                  type="checkbox"
                  @click="(e) => onCheckboxChange(e, cl)"
                  :name="cl.value"
                  :id="cl.text"
                  :checked="cl.value"
                />
                <div class="checkmark"></div>
              </div>
            </div>
            <div class="dt-list-item--body" :class="[cl.dataState]">
              {{ $t(cl.tkey) }}
            </div>
            <div
              v-if="
                booking.cdate.contracts_sent_date &&
                cl.name == 'contracts_out_flag'
              "
              class="dt-list-item--body contracts_sent_date"
            >
              {{ $t(booking.cdate.contracts_sent_date) }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="confirmedInvoices && confirmedInvoices.length > 0"
        class="dt-list-group--item"
        style="padding-bottom: 2px"
      >
        <div class="group-icon">
          <img class="dt-icon s2" :src="`static/icons/${invoiceIcon}`" alt />
        </div>
        <div
          v-if="confirmedInvoices && confirmedInvoices.length > 0"
          class="group-title ut-text-secondary"
        >
          {{$t('invoices')}}
        </div>

        <div class="group-body">
          <table class="invoices-table-container">
            <tbody>
              <tr
                class="invoices-table-row"
                v-for="inv of confirmedInvoices"
                :key="inv.invoice_id"
              >
                <td class="invoices-table-cell">
                  <div class="invoice-status">
                    <div
                      class="color"
                      :style="{
                        backgroundColor: `${getInvoiceStatColor(inv['color'])}`,
                        width: '10px',
                        height: '10px',
                        borderRadius: '20px',
                        marginTop: '1px',
                        marginRight: '4px',
                        minWidth: '10px',
                      }"
                    ></div>
                  </div>
                </td>
                <td class="invoices-table-cell invoice-ref txtov">
                  <div class="txtov">
                    <router-link
                      class="dt-button v3 txtov"
                      :title="inv['invoice_ref']"
                      :to="toRoute(inv)"
                      style="margin-left: 5px"
                    >
                      {{ inv.invoice_ref }}
                    </router-link>
                  </div>
                </td>
                <td
                  class="invoices-table-cell invoice-forwarding"
                  v-if="
                    any(
                      (inv) => inv.artist_invoice_forward_count > 0,
                      confirmedInvoices
                    )
                  "
                >
                  <div class="">
                    <v-menu
                      open-on-hover
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      v-if="inv.artist_invoice_forward_count > 0"
                    >
                      <div slot="activator" class="dt-icon-container">
                        <img
                          src="static/icons/fast-forward.svg"
                          class="dt-icon v2 s16p"
                          :alt="$t('fast_forward')"
                          :title="$t('fast_forward')"
                          @mouseover="(e) => onFastHover(inv['invoice_id'])"
                          @mouseleave="(e) => onFastLeave(inv['invoice_id'])"
                        />
                      </div>
                      <div style="">
                        <ForwardHoverPayments :artistPayments="hoverPayments" />
                      </div>
                    </v-menu>
                  </div>
                </td>
                <td class="invoices-table-cell invoice-amount ut-text-right">
                  <div class="ut-px-4px txtov">
                    {{ inv.gross_amount_cc }}
                    {{ defaultCurrency ? defaultCurrency.currency_iso : "" }}
                  </div>
                </td>
                <td class="invoices-table-cell invoice-mail">
                  <div>
                    <div class="dt-icon-container">
                      <img
                        @click="(e) => onInvoiceMailClick(inv)"
                        src="static/icons/email/email-grey.svg"
                        class="dt-icon v2 s1"
                        alt
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
   
      </div>
    </div>


  </div>
</template>

<script>
import { mailInvoice } from "../../models/invoice-lines.model";
import { checklist } from "../../models/checklists.model";
import { get } from "lodash";
import { invoiceListLDTRoutes } from "../../../accounting/router/routes";
import { encodeRoute } from "../../../../utility";
import ForwardHoverPayments from "../../../accounting/components/invoices/forward-payments-hover";
import { InvoiceForwardService } from "../../../accounting/services/invoice-forward.service";
import { getInvoiceStatColor } from "../../../accounting/models/color-status";
import { any } from "ramda";

export default {
  props: ["booking", "local_details_confirmed_flag", "lockJson"],
  components: {
    ForwardHoverPayments,
  },
  data: function () {
    return {
      contracts: ["Contracts sent to promoter", "Contracts agreed"],
      hoverPayments: [],
    };
  },
  computed: {
    checklist: function () {
      return checklist
        .map((e) => {
          return {
            ...e,
            children: e.children.map((f) => {
              if(e.value == 'travel_details'){
                return {
                  ...f,
                  ...this.travelCheckbox,
                };
              }else{
                const value = get(this.booking, f.xpath) == `1`;
                // console.log("VALUE",f)
                return {
                  ...f,
                  value,
                };
              }
            }),
          };
        });
    },
    confirmedInvoices: function () {
      return this.booking?.invoices || [];
    },
    defaultCurrency: function () {
      return this.booking?.currencies?.find((cur) => {
        if (cur.currency_id == this.booking?.cdate?.currency_id) {
          return true;
        } else {
          return false;
        }
      });
    },
    financeIcon: function () {
      const invoiceStatus = this.booking?.booking_invoice_status;
      if (invoiceStatus == "g2") {
        return "static/icons/finance/finance-active.svg";
      } else if (invoiceStatus == "o2") {
        return "static/icons/finance/finance-orange.svg";
      } else if (invoiceStatus == "r2") {
        return "static/icons/finance/finance-inactive.svg";
      }
    },
    invoiceIcon: function () {
      // if (invoices_out_flag.value) {
      //   return 'finance/finance-orange.svg';
      // } else {
      //   }

      /*
      console.log({ confirmedInvoices: this.confirmedInvoices });
      if (this.confirmedInvoices.every((i) => i.color == "#07f300")) {
        return "invoice-active.svg";
      } else if (
        this.confirmedInvoices.every(
          (i) => i.color == "#fd5b2c" || i.color == "#ca0005"
        )
      ) {
        return "invoice-inactive.svg";
      }
      return "invoice-orange.svg";
      */

      switch (this.booking?.finance_status) {
        case 'RED':
          return 'invoice-inactive.svg';
        case 'GREEN':
          return 'invoice-active.svg';
        case 'YELLOW':
          return 'invoice-orange.svg';
        default:
          return 'invoice-orange.svg';
      }
    },
    travelCheckbox(){
      const travels = get(this.booking, 'travels', []);
      let name = "";   //checkbox type ID key
      let tkey = "";  // i18n Key for checkbox label.
      let value = false;  // is Checked or not.

      if(travels.length == 0 && get(this.lockJson, 'no_travel_needed', 0) == 1){
        name = "no_travel_needed_flag";
        tkey = "no_travel_needed";
        value = true;
      }
      else if(travels.length == 0){
        name = "no_travel_needed_flag";
        tkey = "no_travel_needed";
        value = false;
      }
      else if(travels.length > travels.filter(r => r.confirmed_flag == 1).length){
        name = "travel_detail_confirmed_flag";
        tkey = "travel_details_confirmed";
        value = false;
      }
      else{
        name = "travel_detail_confirmed_flag";
        tkey = "travel_details_confirmed";
        value = true;
      }

      return {name, tkey, value};
    },
  },
  methods: {
    getInvoiceStatColor: getInvoiceStatColor,
    onCheckboxChange: function (e, cl) {
      console.log("WERE", e.target.checked, cl);
      const checked = e.target.checked;

      if (cl.name == "travel_detail_confirmed_flag") {
        this.$emit("tdf_updated", {
          item: this.booking?.cdate,
          name: cl.name,
          value: checked ? 1 : 0,
        });
      } else if (cl.name == "no_travel_needed_flag") {
        this.$emit("no_travel_needed_flag_changed", checked);
      } else if (cl.name == "local_details_confirmed_flag") {
        this.$emit("local_details_confirmed_flag_changed", checked);
      } else {
        this.$emit("updated", {
          item: this.booking?.cdate,
          name: cl.name,
          value: checked ? 1 : 0,
        });
      }
    },
    onInvoiceMailClick: function (invoiceLine) {
      console.log({ invoiceLine: invoiceLine });
      mailInvoice(invoiceLine);
    },
    toRoute: function (invoice) {
      return {
        name: invoiceListLDTRoutes.names.tab,
        params: {
          invoice_id: invoice.invoice_id,
          tab: "overview",
        },
        query: {
          from: encodeRoute(this.$route),
        },
      };
    },
    onFastHover: async function (invoice_id) {
      const Payments = await InvoiceForwardService.getInvoiceTabForward(
        invoice_id
      );
      this.hoverPayments = Payments.data.artist_payments;
    },
    onFastLeave: function () {},
    any: any,
    //MARK: METHODS
  },
};
</script>

<style lang="scss">
.cmp-booking-bookings-booking_sidewindow-checklist {
  /* min-width: 320px; */
  .dt-list-item--body {
    transition: 100ms ease-out;
    //border: 1px solid #000;

    .dt-list-item--text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      .color {
        margin-left: 0px;
        margin-top: 3px;
      }

      &.text-right {
        text-align: right;
      }

      &:first-child {
        flex: 1.6;
      }

      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4) {
        flex: 0.5;
      }
      &:nth-child(3) {
        margin-top: 2px;
      }
    }

    &.contracts_sent_date {
      color: var(--text-secondary);
    }
  }

  .dt-list-group {
    .dt-list-group--item {
      display: flex;
      flex-direction: row;
      font-size: 13px;
      color: var(--text-primary);
      /* margin: 5px 0px 0px 10px; */

      /* background: blueviolet; */

      .group-icon {
        img {
          // width: 30px;
          // height: 30px;
          margin-top: 0px;
          margin-left: 2px;
        }
      }
      .group-title {
        flex: 1;
        padding: 5px 10px;
        text-transform: capitalize;
        flex-basis: 24%;
        min-width: 68px;
      }
      .group-body {
        flex: 1 0 70%;
        /* min-width: 342px;
        max-width: 342px; */

        .invoices-table-container {
          /* display: flex; */
          padding-left: 4px;
          width: 120px;
          overflow: hidden;
          flex-grow: 0;
          width: 100%;
          tbody {
            width: 100%;
            display: table;
            tr {
              /* background: blanchedalmond; */

              td.invoice-table-cell {
                padding: 0px 4px;
              }
              td:first-child {
                width: 10px;
                max-width: 10px;
              }
              td.invoice-ref {
                /* background: blueviolet; */
              }
              td.invoice-forwarding {
                width: 18px;
              }
              td.invoice-amount {
                text-align: right;
                /* min-width: 100px; */
              }
              td.invoice-mail {
                width: 25px;
                /* background: wheat; */
              }
            }
          }
        }
      }

      &:not(:last-child) {
        border-bottom: 1px solid var(--sprt-10);
      }

      .dt-list-item {
        padding: 0px !important;
        margin: 5px;
        height: 20px;
        /* background: azure; */

        .dt-list-item--body {
          /* display: flex;
          flex-direction: column;
          justify-content: center; */
        }
        .dt-list-item--body:nth-child(3) {
          /* display: flex;
          flex-direction: column;
          justify-content: center; */

          justify-content: flex-end;
          max-width: 80px;
        }
        .dt-list-item--options {
          /* background: wheat; */

          margin-right: 8px;
          flex: 1;
          margin-top: 4px;
          .checkmark {
            // --cm-color: black;
          }
        }
      }
    }
  }

  .dt-list-item {
    border-bottom: none !important;
  }
}
</style>